import React from "react";
import { useState, useRef } from "react";
import BenefitCard from "../BenefitCard";
import "./style.scss";
import { TESTIMONIALS } from "./Testimonialsarray";
import leftarw from "../../assets/images/testimonial/leftarrow.svg";
import rightarw from "../../assets/images/testimonial/rightarrow.svg";
import seperator from "../../assets/images/testimonial/separator.svg";
import disable from "../../assets/images/testimonial/disable.svg";
import disabler from "../../assets/images/testimonial/disabler.svg";
import styled from "styled-components";
const DEFAULT_INDEX = 0;
const SlideButton = styled.button`
  color: #ffffff;
  padding: 10px;
  background-color: #ffffff;

  text-decoration: none;
  display: inline-block;
  cursor: pointer;
  margin-top: 4px;

  text-decoration: none;
  float: right;

  &:active {
    position: relative;
    top: 1px;
  }
  &:focus {
    outline: 0;
  }
`;
const CarouselStep = ({
  index,
  activeIndex,
  img,
  customer,
  subtitle,
  description,
  starImg,
  onMouseEnter,
  isProductsPage = false,
}) => {
  return (
    <div
      className={`carouselStep ${
        index === activeIndex && "carouselStep--active"
      }`}
    >
      <BenefitCard
        icon={img}
        title={customer}
        subtitle={subtitle}
        description={description}
        starImg={starImg}
        isProductsPage={isProductsPage}
      />
    </div>
  );
};
const CarouselTypesWrapper = (props) => {
  return (
    <div
      className={`testimonialWrapper__testimonialsWrapper carouselView ${
        props.isProductsPage ? "productPageContainer" : ""
      }`}
      style={{ width: "100%" }}
      ref={props.reference}
      onScroll={props.onScroll}
    >
      {Object.values(props.testimonials).map((step, index) => (
        <CarouselStep
          index={index}
          key={index}
          {...step}
          activeIndex={props.state}
          isProductsPage={props.isProductsPage || false}
        />
      ))}
    </div>
  );
};

const Carousel = (props) => {
  const { showRadioButton = false } = props;
  const testimonials = props.testimonials ?? TESTIMONIALS;
  const [activeIndex, setActiveIndex] = useState(DEFAULT_INDEX);
  const ref = useRef(null);

  const getCardWidth = () => {
    if (!ref.current) return 1250;
    const firstCard = ref.current.querySelector('.carouselStep');
    if (!firstCard) return 1250;
    
    const computedStyle = window.getComputedStyle(firstCard);
    const width = firstCard.offsetWidth;
    const marginLeft = parseFloat(computedStyle.marginLeft) || 0;
    const marginRight = parseFloat(computedStyle.marginRight) || 0;
    
    return width + marginLeft + marginRight;
  };

  const handleScroll = () => {
    if (!ref.current) return;

    const cardWidth = getCardWidth();
    const currentScroll = ref.current.scrollLeft;
    const calculatedIndex = Math.round(currentScroll / cardWidth);
    
    setActiveIndex(calculatedIndex);
  };

  const scrollRight = (scrollOffset) => {
    if (activeIndex >= 2) {
      setActiveIndex(2);
    } else {
      const cardWidth = getCardWidth();
      ref.current.scrollLeft += cardWidth;
      setActiveIndex(activeIndex + 1);
    }
  };
  const scrollLeft = (scrollOffset) => {
    if (activeIndex <= 0) {
      setActiveIndex(0);
    } else {
      const cardWidth = getCardWidth();
      ref.current.scrollLeft -= cardWidth;
      setActiveIndex(activeIndex - 1);
    }
  };

  const scrollToIndex = (index) => {
    if (!ref.current) return;

    const cardWidth = getCardWidth();
    ref.current.scrollTo({
      left: index * cardWidth,
      behavior: "smooth",
    });
    setActiveIndex(index);
  };

  return (
    <div className="slidercarousel">
      <div className={`temp ${props.isProductsPage ? "productPageHeading" : ""}`}>
        <h1 className="heading">{props.heading}</h1>
        <div className="arrw">
          <SlideButton float="right">
            <img
              src={activeIndex >= 2 ? disabler : rightarw}
              alt="icon"
              loading="lazy"
              onClick={() => scrollRight(1250)}
            />
          </SlideButton>

          <SlideButton float="left">
            <img
              src={activeIndex <= 0 ? disable : leftarw}
              alt="icon"
              loading="lazy"
              onClick={() => scrollLeft(1250)}
            />
            <img
              src={seperator}
              alt="separator"
              style={{ paddingLeft: "20px" }}
            />
          </SlideButton>
        </div>
      </div>
      <CarouselTypesWrapper
        state={activeIndex}
        reference={ref}
        testimonials={testimonials}
        isProductsPage={props.isProductsPage || false}
        onScroll={handleScroll}
      />

      {showRadioButton && (
        <div className="hero_radioContainer featured_radio_controller">
          {Object.values(testimonials).map((_, index) => (
            <div
              key={index}
              className={`radioWrapper ${
                index === activeIndex ? "activeRadioWrapper" : ""
              }`}
              onClick={() => scrollToIndex(index)}
            >
              <input
                className={`herodot ${index === activeIndex ? "active" : ""}`}
                type="radio"
                name="carousel_slider"
                checked={index === activeIndex}
                readOnly
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Carousel;
